<script lang="ts">
    import Logo from '$lib/components/assets/Logo.svelte';
    import {replaceState} from '$app/navigation';
    import {getContext} from 'svelte';
    import {keyIsNativePlatform} from '$lib/context-keys';

    interface Props {
        showLogo?: boolean
    }

    let {showLogo = true}: Props = $props()

    const isNativePlatform = getContext(keyIsNativePlatform)

    function reloadPage() {
        if (isNativePlatform) {
            replaceState(window.location.origin, {}) // reload on subroute not possible on mobile
        }
        window.location.reload();
    }
</script>

<div id="app-error-wrapper">
    <div>
        {#if showLogo}
            <Logo size="midi"/>
        {/if}
        <p>
            <b>Ooops!</b> Something went wrong.<br>
        </p>
        <p>
            Our team has been notified, and we're on it! Please try refreshing the page or check back soon.
        </p>
        <button onclick={reloadPage}>Refresh Page »</button>
        <p>
            If the issue persists, feel free to reach out to us at <u>support@vocabeo.com</u> - we're happy to help!
        </p>
    </div>
</div>

<style>
    #app-error-wrapper {
        display: grid;
        grid-template-rows: 1fr max-content 2fr;
        place-items: center;
        width: 100%;
        height: 100%;
        padding-block: 2rem;
        background: var(--color-light);
        /*border: 1px solid blue;*/
    }

    #app-error-wrapper > div {
        grid-row: 2;
        width: min(80%, 30rem);
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 1.5rem;
        /*border: 1px solid magenta;*/
    }

    p {
        margin: 0;
        text-align: center;
    }

    button {
        padding: .8rem 1rem;
        font-weight: var(--font-emph);
        background: var(--color-accent);
        color: white;
    }
</style>
